
import {
  CapacityItem,
  SupportFabricOption,
  FabricCapacity,
} from "./definations";
import { Vue, Component, Ref } from "vue-property-decorator";
import { BgFormItem } from "@banggood/scm-fe";
import { Form } from "element-ui";
import { dateTimeFormat } from "@/utils";
import { scrollElementFormErrorIntoView } from "@/utils";
import CategoryPicker from "@/components/category-picker/index.vue";
import { NewCategory } from "@/service/product/entity/NewCategory";
import { clothingCategoryId } from "@/service/supplier-meta/common/supplier-info-service";
import { getEnum } from "@/service/supplier-meta/api";
import {
  addSupplierReportCapacity,
  getLastMonthCapacity,
  getNextMonthCapacity,
} from "@/service/ewold/api/supplierReportCapacity";
import { SupplierReportCapacityRequestDTO } from "@/service/ewold/entity/SupplierReportCapacityRequestDTO";
import {
  categoryNameSeparator,
  categoryIdSeparator,
  monthCapacityStatusEnum,
} from "../definations";
import { SupplierReportCapacityResponseDTO } from "@/service/ewold/entity/SupplierReportCapacityResponseDTO";
import MonthCapacityStatus from "../components/monthCapacityStatus/index.vue";
interface Node {
  data?: NewCategory;
  label: string;
  pathLabels: string[];
  value: string;
  path: string[];
}
/**
 * 生成提报月份
 */
function genSubmitMonthDateStr(): string {
  const date = new Date();
  date.setMonth(date.getMonth() + 1);
  return dateTimeFormat(date, "yyyy-mm");
}
/**
 * 生成提报截止日期
 */
function genSubmitDealine(): Date {
  const date = new Date();
  date.setDate(23); //每月23日截止
  return date;
}
/**
 * 生成提报截止日期
 */
function genSubmitDealineStr(): string {
  const date = genSubmitDealine();
  return dateTimeFormat(date, "yyyy-mm-dd");
}
function commonValueValidator(
  rules: unknown,
  value: string,
  callback: (msg?: string) => void
) {
  const isEmpty = value === null || value === "";
  if (!isEmpty) {
    if (/^[+-]?\d+$/.test(value)) {
      const val = +(value as string);
      const max = 999999;
      const min = 0;
      if (val < min || val > max) {
        callback(`输入值必须大于等于${min}且小于等于${max}`);
      } else {
        callback();
      }
    } else {
      callback("请输入整数");
    }
  } else {
    callback();
  }
}
@Component({
  components: {
    BgFormItem,
    CategoryPicker,
    MonthCapacityStatus,
  },
})
export default class CapacityManage extends Vue {
  form = {
    supportFabric: [] as string[],
    workDays: null as number | null,
    categories: [] as string[][],
    item: {
      daily: {
        fabrics: [],
        monthReorder: "",
        monthNewProduct: "",
      },
      banggood: {
        fabrics: [],
        monthReorder: "",
        monthNewProduct: "",
      },
    } as CapacityItem,
  };
  submitMonth = genSubmitMonthDateStr();
  submitDealine = genSubmitDealineStr();
  checkedCategoryNodes: Node[] = [];
  status: number | null = null;
  rejectReason = "";
  @Ref("form") elFormComponent!: Form;
  rules = {
    supportFabric: [
      { required: true, message: "请选择支持面料", trigger: "change" },
    ],
    categories: [
      { required: true, message: "请选择主生产品类", trigger: "change" },
    ],
    workDays: [
      { required: true, message: "请填写工作日", trigger: "blur" },
      {
        validator: (
          rules: unknown,
          value: string,
          callback: (msg?: string) => void
        ) => {
          const isEmpty = value === null || value === "";
          if (!isEmpty && !/^\d+$/.test(value)) {
            callback("请输入整数");
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
    ],
  };
  capacityValueRules = [
    {
      validator: commonValueValidator,
      trigger: "blur",
    },
  ];
  monthReorderRules = [
    { required: true, message: "请输入月返单数量", trigger: "blur" },
    {
      validator: commonValueValidator,
      trigger: "blur",
    },
  ];
  monthNewProductRules = [
    { required: true, message: "请输入月新品数量", trigger: "blur" },
    {
      validator: commonValueValidator,
      trigger: "blur",
    },
  ];
  supportFabricOptions: SupportFabricOption[] = [];
  loading = false;
  submitting = false;
  categoryPickerState = {
    visible: false,
    value: [] as string[][],
  };
  get editable() {
    if (this.isExpired()) {
      return false;
    }
    if (typeof this.status === "number") {
      const pendingStatus = monthCapacityStatusEnum.pending;
      const rejectedStatus = monthCapacityStatusEnum.rejected;
      return [pendingStatus, rejectedStatus].includes(this.status);
    } else {
      return this.status === null;
    }
  }
  get statusVisible() {
    return this.status === monthCapacityStatusEnum.rejected;
  }
  async mounted() {
    this.supportFabricOptions = await this.getSupportFabricOptions(); // 表格数据依赖该数据
    this.renderPage();
  }
  getCategoryFullname(node: Node) {
    return node.pathLabels.join(categoryNameSeparator);
  }
  async renderPage() {
    // 超过截止日期
    if (this.isExpired()) {
      return;
    }
    this.loading = true;
    const sbmitDataRes = await getNextMonthCapacity();
    if (!sbmitDataRes.is_success) {
      this.loading = false;
    }
    const pendingStatus = monthCapacityStatusEnum.pending;
    const rejectStatus = monthCapacityStatusEnum.rejected;
    let status =
      sbmitDataRes.result?.status !== undefined
        ? sbmitDataRes.result.status
        : null;
    const wouldSubmit = [pendingStatus, rejectStatus, null].includes(status);
    this.status = status;
    if (wouldSubmit) {
      if (status === rejectStatus) {
        //被驳回，用被驳回的数据填充页面
        let data = sbmitDataRes.result;
        this.rejectReason = data?.remark || "";
        this.fillWidthData(data as SupplierReportCapacityResponseDTO);
      } else {
        const lastMonthRes = await getLastMonthCapacity();
        if (lastMonthRes.is_success && lastMonthRes.result) {
          this.fillWidthData(lastMonthRes.result);
        }
      }
      this.$emit("pendingCountChange", 1); //待处理数量
    } else {
      this.$emit("pendingCountChange", 0); //待处理数量
    }
    this.loading = false;
  }
  refreshPage() {
    this.status = null;
    this.renderPage();
  }
  /**
   * 用上个月填写的信息进行填充
   */
  fillWidthData(data: SupplierReportCapacityResponseDTO) {
    // 支持面料
    if (Array.isArray(data.fabric_support_list)) {
      const supportFabric = data.fabric_support_list.filter((ele) => !!ele);
      if (supportFabric.length > 0) {
        this.form.supportFabric = supportFabric;
        this.handleSupportFabricChange();
      }
    }
    // 品类
    if (
      Array.isArray(data.main_product_category_name_list) &&
      Array.isArray(data.main_product_category_id_list)
    ) {
      const categoryNameList = data.main_product_category_name_list.filter(
        (ele) => !!ele
      );
      const categoryIdList = data.main_product_category_id_list.filter(
        (ele) => !!ele
      );
      const nodes: Node[] = [];
      const categories: string[][] = [];
      categoryIdList.forEach((idPathStr, index) => {
        const idPaths = idPathStr.split(categoryIdSeparator);
        const labelPaths = categoryNameList[index].split(categoryNameSeparator);
        const node = {
          label: labelPaths[labelPaths.length - 1],
          pathLabels: labelPaths,
          value: idPaths[idPaths.length - 1],
          path: idPaths,
        };
        nodes.push(node);
        categories.push(idPaths);
      });
      this.form.categories = categories;
      this.checkedCategoryNodes = nodes;
      if (typeof data.work_days === "number" && data.work_days > 0) {
        this.form.workDays = data.work_days;
      }
    }
    // 产能
    if (Array.isArray(this.form.supportFabric)) {
      const fabricSupportList = this.form.supportFabric;
      // 工厂月产能
      if (Array.isArray(data.fabric_month_capacity_factory_list)) {
        this.form.item.daily.fabrics = fabricSupportList.map(
          (fabricKey, index) => {
            return {
              key: fabricKey,
              name: this.getNameByFabricKey(fabricKey),
              value: data.fabric_month_capacity_factory_list[index] || "",
            };
          }
        );
      }
      // 分配banggood产能
      if (Array.isArray(data.fabric_month_capacity_banggu_list)) {
        this.form.item.banggood.fabrics = fabricSupportList.map(
          (fabricKey, index) => {
            return {
              key: fabricKey,
              name: this.getNameByFabricKey(fabricKey),
              value: data.fabric_month_capacity_banggu_list[index] || "",
            };
          }
        );
      }
    }
    // 工厂月返单
    if (
      typeof data.monthly_reorder_factory === "number" &&
      data.monthly_reorder_factory > 0
    ) {
      this.form.item.daily.monthReorder = data.monthly_reorder_factory + "";
    }
    // 工厂月新品
    if (
      typeof data.monthly_new_designs_factory === "number" &&
      data.monthly_new_designs_factory > 0
    ) {
      this.form.item.daily.monthNewProduct =
        data.monthly_new_designs_factory + "";
    }
    // 分配banggood月返单
    if (
      typeof data.monthly_reorder_banggu === "number" &&
      data.monthly_reorder_banggu > 0
    ) {
      this.form.item.banggood.monthReorder = data.monthly_reorder_banggu + "";
    }
    // 分配banggood月新品
    if (
      typeof data.monthly_new_designs_banggu === "number" &&
      data.monthly_new_designs_banggu > 0
    ) {
      this.form.item.banggood.monthNewProduct =
        data.monthly_new_designs_banggu + "";
    }
  }
  getNameByFabricKey(key: string) {
    const match = this.supportFabricOptions.find((ele) => ele.value === key);
    return match?.label || "";
  }
  async getSupportFabricOptions() {
    const res = await getEnum("SupplierClothesCapacityFabricEnum", true);
    if (Array.isArray(res?.result)) {
      return res.result.map((ele) => ({
        label: ele.desc,
        value: ele.code + "",
      }));
    }
    return [];
  }
  fabricColumns: SupportFabricOption[] = [];
  getItemFabricCapacityIndexByFabricValue(
    itemFabricCapacities: FabricCapacity[],
    fabricValue: string
  ) {
    return itemFabricCapacities.findIndex((ele) => ele.key === fabricValue);
  }
  handleSupportFabricChange() {
    this.genFabricColumns();
    console.log("this.fabricColumns", this.fabricColumns);
    this.genItemsFabricCapacityData();
    console.log("item", this.form.item);
    this.elFormComponent.clearValidate();
  }
  genFabricColumns() {
    this.fabricColumns = this.supportFabricOptions.filter((ele) =>
      this.form.supportFabric.includes(ele.value as string)
    );
  }
  filterCategoryPicker(options: NewCategory[]) {
    return options.filter((c) => c.id + "" === clothingCategoryId + "");
  }
  genItemsFabricCapacityData() {
    const item = this.form.item;
    const newDailyFabricData: FabricCapacity[] = [];
    const newBanggoodFabricData: FabricCapacity[] = [];
    this.fabricColumns.forEach((fCol) => {
      const existDailyFabricCapacityData = item.daily.fabrics.find(
        (f) => f.key === fCol.value
      );
      if (existDailyFabricCapacityData) {
        newDailyFabricData.push(existDailyFabricCapacityData);
      } else {
        newDailyFabricData.push({
          name: fCol.label,
          key: fCol.value as string,
          value: "",
        });
      }
      const existBanggoodFabricCapacityData = item.banggood.fabrics.find(
        (f) => f.key === fCol.value
      );
      if (existBanggoodFabricCapacityData) {
        newBanggoodFabricData.push(existBanggoodFabricCapacityData);
      } else {
        newBanggoodFabricData.push({
          name: fCol.label,
          key: fCol.value as string,
          value: "",
        });
      }
    });
    item.daily.fabrics = newDailyFabricData;
    item.banggood.fabrics = newBanggoodFabricData;
  }
  removeCategory(index: number) {
    this.checkedCategoryNodes = this.checkedCategoryNodes.filter((node) => {
      return (
        JSON.stringify(node.path) !==
        JSON.stringify(this.form.categories[index])
      );
    });
    this.form.categories.splice(index, 1);
  }
  showCategoryPicker() {
    console.log("this.form.categories", this.form.categories);
    this.categoryPickerState.visible = true;
    this.categoryPickerState.value = this.form.categories;
  }
  handleCategoryPickerDone(value: string[][], checkedNodes: Node[]) {
    console.log("handleCategoryPickerDone value", value);
    this.form.categories = value;
    this.checkedCategoryNodes = checkedNodes;
  }
  validate() {
    return this.elFormComponent.validate();
  }
  getSubmitData(): SupplierReportCapacityRequestDTO {
    return {
      fabric_month_capacity_banggu_list: this.form.item.banggood.fabrics.map(
        (f) => f.value
      ),
      fabric_month_capacity_factory_list: this.form.item.daily.fabrics.map(
        (f) => f.value
      ),
      fabric_support_list: this.form.supportFabric,
      main_product_category_id_list: this.form.categories.map((idPath) =>
        idPath.join(categoryIdSeparator)
      ),
      main_product_category_name_list: this.checkedCategoryNodes.map((node) =>
        node.pathLabels.join(categoryNameSeparator)
      ),
      monthly_new_designs_banggu: +this.form.item.banggood.monthNewProduct,
      monthly_new_designs_factory: +this.form.item.daily.monthNewProduct,
      monthly_reorder_banggu: +this.form.item.banggood.monthReorder,
      monthly_reorder_factory: +this.form.item.daily.monthReorder,
      report_deadline: this.submitDealine,
      report_month: this.submitMonth,
      work_days: +(this.form.workDays as number),
    };
  }
  isExpired() {
    let dateValid = false;
    const date = dateTimeFormat(new Date(), "yyyymmdd");
    const dealineDate = dateTimeFormat(genSubmitDealine(), "yyyymmdd");
    dateValid = +date <= +dealineDate;
    return !dateValid;
  }
  async submit() {
    if (this.isExpired()) {
      this.$message.warning("已超过本月提报截止日期，请下个月再进行提报");
      return;
    }
    const formValid = await this.validate().catch(() => false);
    if (!formValid) {
      this.$message.warning("请按要求填写");
      scrollElementFormErrorIntoView(this.elFormComponent);
      return;
    }
    this.submitting = true;
    const res = await addSupplierReportCapacity(this.getSubmitData());
    this.submitting = false;
    if (res.is_success) {
      this.$message.success("提报成功！");
      this.refreshPage();
    }
  }
  cancel() {
    this.$emit("cancel");
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const microApp = (window as any).microApp;
    if (microApp) {
      microApp.dispatch({ event: "cancel", timestamp: new Date().getTime() });
    }
  }
}
